import { render, staticRenderFns } from "./TableControls.vue?vue&type=template&id=831b8638"
import script from "./TableControls.vue?vue&type=script&lang=js"
export * from "./TableControls.vue?vue&type=script&lang=js"
import style0 from "./TableControls.vue?vue&type=style&index=0&id=831b8638&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports